import "./MareaMezcalExperience.module.css";
import Header from "@/reusable_sections/Header";
import QueIncluyeLaExperiencia from "./sections/QueIncluyeLaExperiencia";
import FeaturedExperiences from "./sections/FeaturedExperiences";
import Galeria from "./sections/Galeria";
import Testimonios from "./sections/Testimonios";
import Reservas from "./sections/Reservas";
import Ubicacion from "./sections/Ubicacion";
import Footer from "@/reusable_sections/Footer";
export default function MareaMezcalExperiencePage() {
  return <div>
      <Header />
      <QueIncluyeLaExperiencia />
      <FeaturedExperiences />
      <Galeria />
      <Testimonios />
      <Reservas />
      <Ubicacion />
      <Footer />
    </div>;
}